<template>
  <header class="header">
    <app-advertising-filter v-if="visualizarCampanha"
                            data-entity="statistics"
                            :multiple="false"></app-advertising-filter>

    <app-date-range-statistic-filter data-entity="statistics"></app-date-range-statistic-filter>

    <local-estableshiment-filter data-entity="statistics" />

    <button class="btn btn-extra-round btn-primary"
            @click="emitFilterLoad">{{$t('message.generics.message.fetchData')}}</button>

    <i class="mdi mdi-file-download-outline mr-4"
       v-tooltip.auto="$t('message.statistics.message.exportReport')"
       @click="downloadExcell"></i>
  </header>
</template>

<script>
import LocalEstableshimentFilter from "@components/filters/LocalEstableshimentFilter";
import AppAdvertisingFilter from "@components/filters/AdvertisingFilter";
import AppDateRangeStatisticFilter from "@components/filters/DateRangeStatisticFilter";
import EventBus from "@packages/event-bus";

export default {
  components: {
    AppDateRangeStatisticFilter,
    AppAdvertisingFilter,
    LocalEstableshimentFilter,
  },
  computed: {
    permissions() {
      return this.$store.state.users.user.permissions;
    },
    visualizarCampanha() {
      return this.permissions.includes("READ_CAMPAIGN");
    },
    filters() {
      return this.$store.state.statistics.filters;
    },
  },
  methods: {
    async downloadExcell() {
      try {
        EventBus.$emit("SHOW_SPINNER");

        const excell = await this.fetchexcell();

        const link = this.createElementExcell(excell);

        link.click();
      } catch (error) {
        console.log(error);
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },

    async fetchexcell() {
      return this.$loader.statistics.excell({ filters: this.filters });
    },

    createElementExcell(excell) {
      const url = window.URL.createObjectURL(new Blob([excell]));
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", "Excel-Acessos.xls");
      document.body.appendChild(link);

      return link;
    },

    emitFilterLoad() {
      EventBus.$emit("STATISTICS_FILTER_RELOAD");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.header {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    margin-right: 15px;

    &:last-child {
      margin-right: 0;
    }
  }

  .btn {
    flex-shrink: 0;
  }

  .mdi {
    font-size: 28px;
    color: $grey-6;
    cursor: pointer;

    &.active {
      color: $blue-primary;
    }

    &.mdi-view-grid {
      font-size: 22px;
    }
  }
}
</style>
